import React from 'react';

// Simple replacement for react-if-elseif-else-render
// Maintains similar API for backward compatibility

export const If = ({ condition, children }) => {
  if (!children) return null;
  
  const childArray = React.Children.toArray(children);
  
  // Check if condition is true
  if (condition) {
    // Find and render Then component
    const thenChild = childArray.find(child => child.type === Then);
    return thenChild ? thenChild.props.children : null;
  }
  
  // Check ElseIf conditions
  for (const child of childArray) {
    if (child.type === ElseIf && child.props.condition) {
      const thenChild = React.Children.toArray(child.props.children).find(c => c.type === Then);
      return thenChild ? thenChild.props.children : null;
    }
  }
  
  // Render Else component if exists
  const elseChild = childArray.find(child => child.type === Else);
  return elseChild ? elseChild.props.children : null;
};

export const Then = ({ children }) => {
  return <>{children}</>;
};

export const ElseIf = ({ condition, children }) => {
  return <>{children}</>;
};

export const Else = ({ children }) => {
  return <>{children}</>;
};

export default { If, Then, ElseIf, Else };

